export default __webpack_public_path__ + "static/media/google_Logo.efa560d3.svg";